import { faCheck, faEject, faPlay, faTrash, faXmark } from "@fortawesome/free-solid-svg-icons";
import { GridCellProps } from "@progress/kendo-react-grid";
import { useTheme } from "@mui/material";
import { SprKey, sprKeyIsInValid } from "../../SprKey";
import { KendoGridCommandCellButton } from "./KendoGridCommandCellButton";
import { DELETABLE_FIELD, EDIT_FIELD } from "../../../../Grid/GridConstants";
import { EXCLUDABLE_FIELD, EXCLUDED_FIELD, excludedSprsStyle } from "./ManualSprs";

type Props = {
  gridCellProps: GridCellProps;
  addManuallyAddedSprKey: (sprKey: SprKey) => void;
  cancelAdd: () => void;
  removeManuallyAddedSprKey: (sprKey: SprKey) => void;
  excludeSprKey: (sprKey: SprKey) => void;
  revokeExclusion: (sprKey: SprKey) => void;
  disableCommandIcons: boolean;
};

export const AffectedSprsCommandCell = ({
  gridCellProps,
  addManuallyAddedSprKey,
  cancelAdd,
  removeManuallyAddedSprKey,
  excludeSprKey,
  revokeExclusion,
  disableCommandIcons,
}: Props) => {
  const { dataItem: sprKey } = gridCellProps;

  const theme = useTheme();
  const style = sprKey[EXCLUDED_FIELD] ? excludedSprsStyle(theme) : {};

  return (
    <td className="k-command-cell" style={style}>
      {sprKey[EDIT_FIELD] && (
        <>
          <KendoGridCommandCellButton
            gridCellProps={gridCellProps}
            faIcon={faCheck}
            onClick={() => addManuallyAddedSprKey(sprKey)}
            disabled={disableCommandIcons || sprKeyIsInValid(sprKey as SprKey)}
            title="Add SPR"
          />
          <KendoGridCommandCellButton
            gridCellProps={gridCellProps}
            faIcon={faXmark}
            onClick={cancelAdd}
            title="Cancel add"
            disabled={disableCommandIcons}
          />
        </>
      )}
      {sprKey[DELETABLE_FIELD] && (
        <KendoGridCommandCellButton
          gridCellProps={gridCellProps}
          faIcon={faTrash}
          onClick={() => removeManuallyAddedSprKey(sprKey as SprKey)}
          title="Delete manually added SPR"
          disabled={disableCommandIcons}
        />
      )}
      {sprKey[EXCLUDABLE_FIELD] && (
        <KendoGridCommandCellButton
          gridCellProps={gridCellProps}
          faIcon={faEject}
          onClick={() => excludeSprKey(sprKey as SprKey)}
          title="Exclude SPR"
          disabled={disableCommandIcons}
        />
      )}
      {sprKey[EXCLUDED_FIELD] && (
        <KendoGridCommandCellButton
          gridCellProps={gridCellProps}
          faIcon={faPlay}
          onClick={() => revokeExclusion(sprKey as SprKey)}
          title="Unexclude SPR"
          disabled={disableCommandIcons}
        />
      )}
    </td>
  );
};
